import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from '@nuxtjs/composition-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

const store = useStore();
const logotypesFromCdn = store.getters['config/getLogotypes'];

const logotype = computed(() => {
  const { logotypeDesktop, logotypeMobile } = logotypesFromCdn;
  return logotypeDesktop || logotypeMobile || undefined;
});

return { __sfc: true,store, logotypesFromCdn, logotype }
}

})